import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { getAccountsPatient } from './api/index';
import { IAdminPatients } from './api/type';
import Layout from './components/Layout';
import useNotification from 'hooks/useNotification';
import useTable from 'hooks/useTable';
import { getSearchQuery } from 'utils/searchQuery';

import ListBody from './ListBody';
import ListHeader from './ListHeader';
import useUser from 'store/user/useUser';

function PatientList() {
  const { search } = useLocation();
  const {
    page = 1,
    approve,
    keyword,
    searchType,
    patient_id,
    college,
    user_id,
  } = getSearchQuery(search);

  const { student_uuid: userId } = useUser();

  const {
    list,
    setList,
    totalCount,
    setTotalCount,
    isLoading,
    setIsLoading,
    selected,
    setSelected,
    onPageChange,
  } = useTable<IAdminPatients>();
  const { onSuccess, onFail, onRequired } = useNotification();

  const [refresh, setRefresh] = useState(1);

  const handleAddFriend = () => {
    //데이터 핸들링할때 reFresh값에 변화를 준다.
    setRefresh(refresh => refresh * -1);
  };

  // 목록 조회
  const onGetList = useCallback(() => {
    setSelected([]);
    setIsLoading(true);

    getAccountsPatient({
      page: String(page),
      approve,
      keyword,
      searchType,
      college,
      user_id: String(userId),
    })
      .then(({ data }) => {
        setList(data.patients);
        setTotalCount(data.count);
      })
      .catch(e => {
        const message = `가상환자 목록을 불러오는데 실패했습니다.`;
        onFail(message, e);
      })
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line
  }, [approve, page, keyword, searchType, patient_id, college]);

  // Page 변경되는 경우 목록 갱신
  useEffect(onGetList, [onGetList, refresh]);

  return (
    <Layout currentMenu={`Өвчтөний виртуал жагсаалт`}>
      <ListHeader
        totalCount={totalCount}
        setTotalCount={setTotalCount}
        currentApprove={approve as any}
        currentSearchType={searchType as any}
        onRequired={onRequired}
        selected={selected}
        list={list}
        setList={setList}
        handleAddFriend={handleAddFriend}
        setIsLoading={setIsLoading}
      />
      <ListBody
        list={list}
        isLoading={isLoading}
        totalCount={totalCount}
        page={Number(page) - 1}
        selected={selected}
        onSelected={setSelected}
        onPageChange={onPageChange}
      />
    </Layout>
  );
}

export default PatientList;
